/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as LangIndexImport } from './routes/$lang/index'
import { Route as LangProfileRouteImport } from './routes/$lang/profile/route'
import { Route as LangProfileInviteImport } from './routes/$lang/profile/invite'
import { Route as LangProfileGemImport } from './routes/$lang/profile/gem'
import { Route as LangProfileDepositImport } from './routes/$lang/profile/deposit'
import { Route as LangProfileCreationImport } from './routes/$lang/profile/creation'
import { Route as LangProfileContactImport } from './routes/$lang/profile/contact'
import { Route as LangProfileCommentImport } from './routes/$lang/profile/comment'
import { Route as LangProfileAccountImport } from './routes/$lang/profile/account'
import { Route as LangEditIdImport } from './routes/$lang/edit/$id'
import { Route as LangAuthSocialImport } from './routes/$lang/auth/social'
import { Route as LangAuthEmailImport } from './routes/$lang/auth/email'
import { Route as LangStoryCreationidDialogueidImport } from './routes/$lang/story/$creation_id.$dialogue_id'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LangIndexRoute = LangIndexImport.update({
  id: '/$lang/',
  path: '/$lang/',
  getParentRoute: () => rootRoute,
} as any)

const LangProfileRouteRoute = LangProfileRouteImport.update({
  id: '/$lang/profile',
  path: '/$lang/profile',
  getParentRoute: () => rootRoute,
} as any)

const LangProfileInviteRoute = LangProfileInviteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangProfileGemRoute = LangProfileGemImport.update({
  id: '/gem',
  path: '/gem',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangProfileDepositRoute = LangProfileDepositImport.update({
  id: '/deposit',
  path: '/deposit',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangProfileCreationRoute = LangProfileCreationImport.update({
  id: '/creation',
  path: '/creation',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangProfileContactRoute = LangProfileContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangProfileCommentRoute = LangProfileCommentImport.update({
  id: '/comment',
  path: '/comment',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangProfileAccountRoute = LangProfileAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => LangProfileRouteRoute,
} as any)

const LangEditIdRoute = LangEditIdImport.update({
  id: '/$lang/edit/$id',
  path: '/$lang/edit/$id',
  getParentRoute: () => rootRoute,
} as any)

const LangAuthSocialRoute = LangAuthSocialImport.update({
  id: '/$lang/auth/social',
  path: '/$lang/auth/social',
  getParentRoute: () => rootRoute,
} as any)

const LangAuthEmailRoute = LangAuthEmailImport.update({
  id: '/$lang/auth/email',
  path: '/$lang/auth/email',
  getParentRoute: () => rootRoute,
} as any)

const LangStoryCreationidDialogueidRoute =
  LangStoryCreationidDialogueidImport.update({
    id: '/$lang/story/$creation_id/$dialogue_id',
    path: '/$lang/story/$creation_id/$dialogue_id',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$lang/profile': {
      id: '/$lang/profile'
      path: '/$lang/profile'
      fullPath: '/$lang/profile'
      preLoaderRoute: typeof LangProfileRouteImport
      parentRoute: typeof rootRoute
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangIndexImport
      parentRoute: typeof rootRoute
    }
    '/$lang/auth/email': {
      id: '/$lang/auth/email'
      path: '/$lang/auth/email'
      fullPath: '/$lang/auth/email'
      preLoaderRoute: typeof LangAuthEmailImport
      parentRoute: typeof rootRoute
    }
    '/$lang/auth/social': {
      id: '/$lang/auth/social'
      path: '/$lang/auth/social'
      fullPath: '/$lang/auth/social'
      preLoaderRoute: typeof LangAuthSocialImport
      parentRoute: typeof rootRoute
    }
    '/$lang/edit/$id': {
      id: '/$lang/edit/$id'
      path: '/$lang/edit/$id'
      fullPath: '/$lang/edit/$id'
      preLoaderRoute: typeof LangEditIdImport
      parentRoute: typeof rootRoute
    }
    '/$lang/profile/account': {
      id: '/$lang/profile/account'
      path: '/account'
      fullPath: '/$lang/profile/account'
      preLoaderRoute: typeof LangProfileAccountImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/profile/comment': {
      id: '/$lang/profile/comment'
      path: '/comment'
      fullPath: '/$lang/profile/comment'
      preLoaderRoute: typeof LangProfileCommentImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/profile/contact': {
      id: '/$lang/profile/contact'
      path: '/contact'
      fullPath: '/$lang/profile/contact'
      preLoaderRoute: typeof LangProfileContactImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/profile/creation': {
      id: '/$lang/profile/creation'
      path: '/creation'
      fullPath: '/$lang/profile/creation'
      preLoaderRoute: typeof LangProfileCreationImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/profile/deposit': {
      id: '/$lang/profile/deposit'
      path: '/deposit'
      fullPath: '/$lang/profile/deposit'
      preLoaderRoute: typeof LangProfileDepositImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/profile/gem': {
      id: '/$lang/profile/gem'
      path: '/gem'
      fullPath: '/$lang/profile/gem'
      preLoaderRoute: typeof LangProfileGemImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/profile/invite': {
      id: '/$lang/profile/invite'
      path: '/invite'
      fullPath: '/$lang/profile/invite'
      preLoaderRoute: typeof LangProfileInviteImport
      parentRoute: typeof LangProfileRouteImport
    }
    '/$lang/story/$creation_id/$dialogue_id': {
      id: '/$lang/story/$creation_id/$dialogue_id'
      path: '/$lang/story/$creation_id/$dialogue_id'
      fullPath: '/$lang/story/$creation_id/$dialogue_id'
      preLoaderRoute: typeof LangStoryCreationidDialogueidImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface LangProfileRouteRouteChildren {
  LangProfileAccountRoute: typeof LangProfileAccountRoute
  LangProfileCommentRoute: typeof LangProfileCommentRoute
  LangProfileContactRoute: typeof LangProfileContactRoute
  LangProfileCreationRoute: typeof LangProfileCreationRoute
  LangProfileDepositRoute: typeof LangProfileDepositRoute
  LangProfileGemRoute: typeof LangProfileGemRoute
  LangProfileInviteRoute: typeof LangProfileInviteRoute
}

const LangProfileRouteRouteChildren: LangProfileRouteRouteChildren = {
  LangProfileAccountRoute: LangProfileAccountRoute,
  LangProfileCommentRoute: LangProfileCommentRoute,
  LangProfileContactRoute: LangProfileContactRoute,
  LangProfileCreationRoute: LangProfileCreationRoute,
  LangProfileDepositRoute: LangProfileDepositRoute,
  LangProfileGemRoute: LangProfileGemRoute,
  LangProfileInviteRoute: LangProfileInviteRoute,
}

const LangProfileRouteRouteWithChildren =
  LangProfileRouteRoute._addFileChildren(LangProfileRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang/profile': typeof LangProfileRouteRouteWithChildren
  '/$lang': typeof LangIndexRoute
  '/$lang/auth/email': typeof LangAuthEmailRoute
  '/$lang/auth/social': typeof LangAuthSocialRoute
  '/$lang/edit/$id': typeof LangEditIdRoute
  '/$lang/profile/account': typeof LangProfileAccountRoute
  '/$lang/profile/comment': typeof LangProfileCommentRoute
  '/$lang/profile/contact': typeof LangProfileContactRoute
  '/$lang/profile/creation': typeof LangProfileCreationRoute
  '/$lang/profile/deposit': typeof LangProfileDepositRoute
  '/$lang/profile/gem': typeof LangProfileGemRoute
  '/$lang/profile/invite': typeof LangProfileInviteRoute
  '/$lang/story/$creation_id/$dialogue_id': typeof LangStoryCreationidDialogueidRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang/profile': typeof LangProfileRouteRouteWithChildren
  '/$lang': typeof LangIndexRoute
  '/$lang/auth/email': typeof LangAuthEmailRoute
  '/$lang/auth/social': typeof LangAuthSocialRoute
  '/$lang/edit/$id': typeof LangEditIdRoute
  '/$lang/profile/account': typeof LangProfileAccountRoute
  '/$lang/profile/comment': typeof LangProfileCommentRoute
  '/$lang/profile/contact': typeof LangProfileContactRoute
  '/$lang/profile/creation': typeof LangProfileCreationRoute
  '/$lang/profile/deposit': typeof LangProfileDepositRoute
  '/$lang/profile/gem': typeof LangProfileGemRoute
  '/$lang/profile/invite': typeof LangProfileInviteRoute
  '/$lang/story/$creation_id/$dialogue_id': typeof LangStoryCreationidDialogueidRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/$lang/profile': typeof LangProfileRouteRouteWithChildren
  '/$lang/': typeof LangIndexRoute
  '/$lang/auth/email': typeof LangAuthEmailRoute
  '/$lang/auth/social': typeof LangAuthSocialRoute
  '/$lang/edit/$id': typeof LangEditIdRoute
  '/$lang/profile/account': typeof LangProfileAccountRoute
  '/$lang/profile/comment': typeof LangProfileCommentRoute
  '/$lang/profile/contact': typeof LangProfileContactRoute
  '/$lang/profile/creation': typeof LangProfileCreationRoute
  '/$lang/profile/deposit': typeof LangProfileDepositRoute
  '/$lang/profile/gem': typeof LangProfileGemRoute
  '/$lang/profile/invite': typeof LangProfileInviteRoute
  '/$lang/story/$creation_id/$dialogue_id': typeof LangStoryCreationidDialogueidRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang/profile'
    | '/$lang'
    | '/$lang/auth/email'
    | '/$lang/auth/social'
    | '/$lang/edit/$id'
    | '/$lang/profile/account'
    | '/$lang/profile/comment'
    | '/$lang/profile/contact'
    | '/$lang/profile/creation'
    | '/$lang/profile/deposit'
    | '/$lang/profile/gem'
    | '/$lang/profile/invite'
    | '/$lang/story/$creation_id/$dialogue_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang/profile'
    | '/$lang'
    | '/$lang/auth/email'
    | '/$lang/auth/social'
    | '/$lang/edit/$id'
    | '/$lang/profile/account'
    | '/$lang/profile/comment'
    | '/$lang/profile/contact'
    | '/$lang/profile/creation'
    | '/$lang/profile/deposit'
    | '/$lang/profile/gem'
    | '/$lang/profile/invite'
    | '/$lang/story/$creation_id/$dialogue_id'
  id:
    | '__root__'
    | '/'
    | '/$lang/profile'
    | '/$lang/'
    | '/$lang/auth/email'
    | '/$lang/auth/social'
    | '/$lang/edit/$id'
    | '/$lang/profile/account'
    | '/$lang/profile/comment'
    | '/$lang/profile/contact'
    | '/$lang/profile/creation'
    | '/$lang/profile/deposit'
    | '/$lang/profile/gem'
    | '/$lang/profile/invite'
    | '/$lang/story/$creation_id/$dialogue_id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangProfileRouteRoute: typeof LangProfileRouteRouteWithChildren
  LangIndexRoute: typeof LangIndexRoute
  LangAuthEmailRoute: typeof LangAuthEmailRoute
  LangAuthSocialRoute: typeof LangAuthSocialRoute
  LangEditIdRoute: typeof LangEditIdRoute
  LangStoryCreationidDialogueidRoute: typeof LangStoryCreationidDialogueidRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangProfileRouteRoute: LangProfileRouteRouteWithChildren,
  LangIndexRoute: LangIndexRoute,
  LangAuthEmailRoute: LangAuthEmailRoute,
  LangAuthSocialRoute: LangAuthSocialRoute,
  LangEditIdRoute: LangEditIdRoute,
  LangStoryCreationidDialogueidRoute: LangStoryCreationidDialogueidRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/$lang/profile",
        "/$lang/",
        "/$lang/auth/email",
        "/$lang/auth/social",
        "/$lang/edit/$id",
        "/$lang/story/$creation_id/$dialogue_id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/$lang/profile": {
      "filePath": "$lang/profile/route.tsx",
      "children": [
        "/$lang/profile/account",
        "/$lang/profile/comment",
        "/$lang/profile/contact",
        "/$lang/profile/creation",
        "/$lang/profile/deposit",
        "/$lang/profile/gem",
        "/$lang/profile/invite"
      ]
    },
    "/$lang/": {
      "filePath": "$lang/index.tsx"
    },
    "/$lang/auth/email": {
      "filePath": "$lang/auth/email.tsx"
    },
    "/$lang/auth/social": {
      "filePath": "$lang/auth/social.tsx"
    },
    "/$lang/edit/$id": {
      "filePath": "$lang/edit/$id.tsx"
    },
    "/$lang/profile/account": {
      "filePath": "$lang/profile/account.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/profile/comment": {
      "filePath": "$lang/profile/comment.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/profile/contact": {
      "filePath": "$lang/profile/contact.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/profile/creation": {
      "filePath": "$lang/profile/creation.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/profile/deposit": {
      "filePath": "$lang/profile/deposit.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/profile/gem": {
      "filePath": "$lang/profile/gem.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/profile/invite": {
      "filePath": "$lang/profile/invite.tsx",
      "parent": "/$lang/profile"
    },
    "/$lang/story/$creation_id/$dialogue_id": {
      "filePath": "$lang/story/$creation_id.$dialogue_id.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
